import React, { forwardRef } from 'react';

import styled from '../../../styled';
import { colorsPalette } from '../../../theme';

interface CardWrapperProps {
  className?: string;
  children: React.ReactNode;
}

const CardWrapper = forwardRef<HTMLDivElement, CardWrapperProps & React.HTMLProps<HTMLDivElement>>(
  ({ children, className = '', ...props }, ref) => {
    const clickable = !!props.onClick;

    return (
      <Wrapper
        // @ts-ignore
        ref={ref}
        className={className}
        clickable={clickable}
        {...props}
      >
        {children}
      </Wrapper>
    );
  },
);

export default CardWrapper;

const Wrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'clickable',
})`
  position: relative;
  padding: 24px;
  background: ${({ clickable }) =>
    clickable ? colorsPalette.blackSecondary : colorsPalette.violetAnalyticsCard};
  box-shadow: 0px 3px 5px ${colorsPalette.black};
  border-radius: 5px;
  cursor: ${({ clickable }) => clickable && 'pointer'};
  transition: background 0.3s;

  &:hover {
    background: ${({ clickable }) =>
      clickable ? colorsPalette.violetAnalyticsCard : colorsPalette.blackSecondary};
  }
`;
